import { useFormikContext } from "formik";
import React, { useState, useEffect } from "react";
import { labelName } from "../../utils/functions";
import TextFieldStyles from "../Input/TextField/TextField.module.css";
import WeightFieldStyles from "./Weight.module.css";
import ErrorMessage from "../Input/ErrorrMessage";

// Array of unit options for the dropdown specific to weight
const unitOfMeasure = ["Kilograms", "Grams", "Pounds", "Ounces", "Tons"];

// Distance component for capturing distance-related inputs
export default function Weight({ field_label, displayLabel, parent, isRequired, initialValue }) {
  // Access Formik's context to set field values
  const { setFieldValue } = useFormikContext();

  // Construct the field name based on parent and field_label
  const name = parent ? `${parent}.${field_label}` : field_label;

  // State to hold the distance values (unit, length, width, height, quantity)
  const [weight, setWeight] = useState(parseWeight(initialValue)); 

  const weightToSave = Object.entries(weight)
      .map(([key, value]) => `${key}: ${value?.trim()}`)
      .join(",");

  useEffect(() => {    
    setFieldValue(name, weightToSave);
  }, [weight, name, setFieldValue]);

  // Function to update a specific index in the distance array
  const updateWeight = (key, value) => {
    setWeight(prev => ({
        ...prev,
        [key]: value
    }));
  };

  function parseWeight(value) {
    const defaults = {
      uom: "Kilograms",
      weight: ""
    };

    if (!value) return defaults;

    return value.split(",").reduce((acc, item) => {
      const [key, val] = item.split(":").map(s => s.trim());
      if (key && val !== undefined) {
        acc[key] = val;
      }
      return acc;
    }, { ...defaults });
  };


  return (
    <div className={TextFieldStyles.inputContainer}>
      {/* Label for the input field */}
      <div className="label-container" style={{ display: "flex", justifyContent: "space-between" }}>
        <label htmlFor="textarea" className={TextFieldStyles.label}>
          {labelName(displayLabel || field_label)}
          {isRequired === "true" && <span style={{ color: "#d32f2f", padding: 0 }}>*</span>}
        </label>
      </div>
      <div style={{ fontFamily: "Arial, sans-serif" }}>
        {/* Hidden input to store the serialized distance state */}
        <input type="hidden" name={name} value={weightToSave} />
        <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
          {/* Dropdown for selecting the unit of measure */}
          <div style={{display: "grid", gap: ".8em"}}>
            <label className={TextFieldStyles.label}>Unit of Measure</label>
            <select
              style={{
                  width: "min-content",
                  fontFamily: "Arial, sans-serif",
                  border: "none",
                  borderBottom: "none",
                  outline: "none",
              }}
              value={weight.uom}
              onChange={(e) => updateWeight("uom", e.target.value)}
            >
              {unitOfMeasure.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>
          {/* Input for weight */}
          <div>
            <label className={TextFieldStyles.label}>Weight</label>
            <input
              type="number"
              placeholder="Enter Weight"
              className={WeightFieldStyles.input}
              value={weight.weight}
              onChange={(e) => updateWeight("weight", e.target.value)}
            />
          </div>
        </div>
      </div>
      {/* Display error message if validation fails */}
      <ErrorMessage name={name} />
    </div>
  );
}
